import React from "react";
import { useNavigate } from 'react-router-dom';
import SectionCard from "../../../components/ui/SectionCard/SectionCard";
import "./OptionCards.css";

export default function OptionCards() {
    const navigate = useNavigate();
    return (
        <div className="options-grid">
            <SectionCard
                title="Lista de SAP"
                description="Visualize todos os servidores SAP."
                actions={[
                { label: "Ver lista de SAP", variant: "primary", onClick: () => navigate('/listaSap')},
                ]}
                accent="#00ade2ff"
            />

            <SectionCard
                title="Gestão de Usuários"
                description="Crie, Gerencie e Gere nova senha para os usuários."
                actions={[
                    { label: "Ir para Usuários", variant: "primary", onClick: () => navigate('/user')},
                ]}
                accent="#2f7d32"
            />

            <SectionCard
                title="Gestão de Condomínios"
                description="Gerencie e crie novos condomínios."
                actions={[
                    { label: "Ir para Condomínios", variant: "primary", onClick: () => navigate('/condominios')},
                ]}
                accent="#2f7d32"
            />

            <SectionCard
                title="Servidores CMD"
                description="Acompanhe os status de todos os servidores da CMD."
                actions={[
                { label: "Ir para Dispositivos", variant: "primary", onClick: () => navigate('/servidores')},
                ]}
                accent="#e2a400"
            />

            <SectionCard
                title="Status das Licenças"
                description="Verifique o Status das licenças do SAP."
                actions={[
                { label: "Ver Licenças", variant: "primary", onClick: () => navigate('/licencas')},
                ]}
                accent="#e20000ff"
            />
    </div>
  );
}
